import React, { useEffect, useState } from "react";
import { ReactComponent as SunIcon } from "./assets/svg/sun-icon.svg";
import { ReactComponent as MoonIcon } from "./assets/svg/moon-icon.svg";

const ThemeSwitcher = () => {
    const [theme, setTheme] = useState(
        localStorage.getItem("theme") || "light"
    );
    useEffect(() => {
        document.documentElement.setAttribute("data-theme", theme);
        // document.body.classList.toggle("dark", theme === "dark");
    }, [theme]);
    const toggleTheme = () => {
        setTheme((prevTheme) => {
            const newTheme = prevTheme === "dark" ? "light" : "dark";
            localStorage.setItem("theme", newTheme);
            return newTheme;
        });
    };
    return (
        <div className="theme-icon" onClick={toggleTheme}>
            {theme === "light" ? <MoonIcon /> : <SunIcon />}
        </div>
    );
};

export default ThemeSwitcher;
